var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({content: _vm.tooltip, html: false}),expression:"{content: tooltip, html: false}"}],class:_vm.classList},[_c('div',{staticClass:"tag-content"},[_c('span',{staticClass:"tag-text"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"addon"},[_vm._t("addon")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }